<template>
    <div class="" v-if="cart">


        <!-- cart.cart={{cart}} -->
        <!-- <br>
        <!-- <hr>
        checkout={{checkout.user}}
        <br>
        <hr> -->
        <!-- coupon={{coupon}} -->
        <span v-html="html"></span>

        <div class="alert alert-success" v-if="success" >
            <span v-html="success"></span>
        </div>
        <div class="alert alert-danger" v-if="error">
            <span v-html="error"></span>

        </div>

        <div v-if="!success && !html">
            <div class="checkout-tabs" v-if="Object.keys(cart).length > 0">


                <b-tabs  v-model="tabIndex"  nav-wrapper-class="nav-tabs-wrapper"  ref="wizard" >
                    <!-- <b-tab title=""  ></b-tab> -->
                    <b-tab disabled></b-tab>
                    <b-tab :title="__('__JSON__.A kosár')" title-item-class="disabledTab">
                        <h2>{{ __('__JSON__.A kosár') }}</h2>
                        <div class="cart-list"  v-if="cart.cart">

                            <ul v-if="cart.cart.data">
                                <!-- f={{ floatingPrecision }} -->
                                <!-- {{ cart }} -->
                                <li class="cartdata" v-for="product in cart.cart.data">
                                    <!-- {{ product }} -->
                                    <div class="product-name">
                                        {{ product.product_name }}<br />
                                        <div class="packaging-qty">{{ product.packaging_qty }} {{ product.packaging_qty_unit }}</div>
                                    </div>


                                    <div class="cart-element">
                                        <roastopus-cart-element-small :product="product" :key="product.product_id"></roastopus-cart-element-small>
                                    </div>
                                    <div class="product-price">
                                        {{ parseFloat(product.price_plus_vat  * product.qty).toFixed(floatingPrecision) }} {{ product.currency}}

                                    </div>
                                </li>
                                <li class="cartdata" v-if="cart.products_total_price_plus_vat == 0">
                                    {{ __('__JSON__.A kosár üres') }}
                                </li>
                                <li class="last">

                                    <div class="total_price">
                                        {{ parseFloat(cart.products_total_price_plus_vat).toFixed(floatingPrecision) }} {{ cart.currency }}
                                    </div>
                                    <div class="checkout" v-if="!cartmenuloading && cart.products_total_price_plus_vat > 0">
                                        <a class="float-end btn btn-checkout" @click="tabIndex2">  {{ btntext }}  </a>
                                    </div>
                                    <div class="checkout" v-if="!cartmenuloading && cart.products_total_price_plus_vat == 0">
                                        <a class="float-end btn btn-checkout btn-disabled disabled" >  {{ btntext }}  </a>
                                    </div>
                                    <div class="checkout" v-if="cartmenuloading">
                                        <a class="float-end btn btn-checkout btn-loading disabled" :href="route"><i class="fas fa-spinner fa-spin"></i>  Kosárművelet x </a>
                                    </div>
                                </li>
                            </ul>


                        </div>

                    </b-tab>

                    <b-tab :title="__('__JSON__.Szállítási mód')" title-item-class="disabledTab">
                        <h2>{{ __('__JSON__.Szállítási mód')}}</h2>
<!-- sz={{  cart.cart.shipping_method }} -->


                        <div class="w80xx">
                            <input type="hidden" id="parcelpoint" name="parcelpoint">
                            <!-- {{ cart.cart.shipping_method }} -->
                            <!-- <div class="radio-inline" v-for="shipping_type in shipping_types"> -->
                            <div class="radio-inline" v-for="(shipping_type, indx) in shipping_types" :key="indx" :class="{'active': cart.cart.shipping_method && shipping_type.id == cart.cart.shipping_method?.id}">
                                <label>
                                    <!-- <input type="radio" name="shipping_method" :value="shipping_type.id" v-model="cart.cart.shipping_method" @change="changeShippingMethod(); checkout.parcelpoint = null "> -->
                                    <input type="radio" name="shipping_method" :value="shipping_type" v-model="cart.cart.shipping_method" @change="changeShippingMethod();checkout.parcelpoint = null ">

                                    <strong>{{ shipping_type.name }}</strong><br />
                                    <p v-html="shipping_type.description"></p>

                                </label>
                                <template   v-if="cart.cart.shipping_method && cart.cart.shipping_method.id  == 'FOXP' && shipping_type.id == 'FOXP' ">
                                <div class="mb-4 radio-inline">                                    <br />
                                    <!-- {{__('__JSON__.Válassz csomagpontot') }}:<br /> -->

                                    <label v-if="checkout.parcelpoint" class="pl-24 mb-2">{{__('__JSON__.Kiválasztva:')}}<br> {{ checkout.parcelpoint.name ?? '' }}<br>
                                    </label>
                                     <button class="btn btn-primary" @click="showParcelPointModal = true">
                                           <span v-if="!checkout.parcelpoint"> {{__('__JSON__.Csomagpont kiválasztása')}} </span>
                                           <span v-if="checkout.parcelpoint"> {{__('__JSON__.Másik csomagpont kiválasztása')}} </span>
                                            </button>
                                  <parcelpoint-select :checkout="checkout"  :userdata_orig="user" v-model="checkout.parcelpoint" :shipping_method="cart.cart.shipping_method"
                                    v-if="showParcelPointModal"
                                        @close="showParcelPointModal = false"
                                        ></parcelpoint-select>
                                </div>
                            </template>
                            <span class="" v-if="cart.cart.shipping_method && cart.cart.shipping_method.id  == 'PACKETERY-' ">
                                <div class="radio-inline">
                                    <br />
                                    {{__('__JSON__.Válassz csomagautomatát (kezdd el beírni a település nevét)') }}:<br />
                                    <parcelpoint-select :checkout="checkout"  :userdata_orig="user" v-model="checkout.parcelpoint" :shipping_method="cart.cart.shipping_method"></parcelpoint-select>
                                </div>
                            </span>
                            </div>


                            <hr>
                            <div class="checkout"  >

                                <a class="float-start btn btn-checkout" @click="tabIndex1">  {{ prevbtntext }}  </a>

                                <!-- <a class="- btn btn-checkout" @click="tabIndex3"
                                v-if="(cart.cart.shipping_method != null)
                                && ((cart.cart.shipping_method == 'FOXP'
                                && checkout.foxpost != null) || (cart.cart.shipping_method == 'FOXH') || (cart.cart.shipping_method == 'GLS'))">  {{ btntext }}  </a> -->
                                <!-- v-if="(cart.cart.shipping_method != null) ">  -->
                                <a class="float-end btn btn-checkout" @click="tabIndex3"
                                v-if="((cart.cart.shipping_method != null && cart.cart.shipping_method.select_required == '0' ) || (cart.cart.shipping_method != null && cart.cart.shipping_method.select_required == '1' && checkout.parcelpoint)) ">
                                {{ btntext }}  </a>

                                <!-- <a class="float-end btn btn-checkout" @click="tabIndex3" v-if="(cart.cart.shipping_method != null) && ((cart.cart.shipping_method == 'FOXP' ) || (cart.cart.shipping_method == 'FOXH'))">  {{ btntext }}  </a> -->
                                <a class="float-end btn btn-checkout btn-disabled disabled"  v-else="cart.cart.shipping_method == null ">  {{ btntext }}  </a>
                            </div>


                        </div>
                    </b-tab>

                    <b-tab :title="__('__JSON__.Fizetési mód')" title-item-class="disabledTab">
                        <h2>{{ __('__JSON__.Fizetési mód')}}</h2>
                        <div class="w80">
                            <!-- {{ payment_methods }} -->
                            <!-- <div class="radio-inline"  v-for="payment in payment_methods"> -->

                             <div  v-for="(payment, indx) in payment_methods" :key="indx"  >


                                <!-- <label v-if="payment.shipping_methods.indexOf(cart.cart.shipping_method) > 0 "> -->

                                    <!-- <input type="radio" name="payment_method" :value="payment.id" v-model="cart.cart.payment_method"  @change="changePaymentMethod"> -->
                                    <div  :class="{'radio-inline': true, 'active': payment.id == cart.cart.payment_method}" v-if="cart.cart.shipping_method && payment.shipping_methods.indexOf(cart.cart.shipping_method.id) > 0 ">
                                    <label >
                                        <input type="radio" name="payment_method" :value="payment.id" v-model="cart.cart.payment_method" @change="changePaymentMethod">
                                         <!-- <div class="circle"></div> -->

                                        <strong>{{ payment.name }}</strong><br />
                                        <p v-html="payment.description"></p>
                                        <p v-if="payment.payment_price > 0">{{ __('__JSON__.Utánvét díja')}}: {{ payment.payment_price }} {{ cart.currency }}</p>
                                        <div v-if="payment.image" class="payment-image"><img :src="'/images/' + payment.image" alt="" class="img-fluid"></div>
                                    </label>
                                </div>
                          </div>

                            <hr>

                            <div class="checkout"  >
                                <a class="float-start btn btn-checkout" @click="tabIndex2">  {{ prevbtntext }}  </a>

                                <a class="float-end btn btn-checkout" @click="tabIndex4" v-if="cart.cart.payment_method != null ">  {{ btntext }}  </a>
                                <a class="float-end btn btn-checkout btn-disabled disabled"  v-else="cart.cart.payment_method == null ">  {{ btntext }}  </a>
                            </div>
                        </div>
                    </b-tab>
                    <b-tab :title="__('__JSON__.Szállítási és számlázási cím')" title-item-class="disabledTab">
                        <h2>{{ __('__JSON__.Szállítási és számlázási cím')}}</h2>
                        <div class="w80 card-form">

                            <div class="form-group row">
                                <h3><div>{{ __('Számlázási adatok') }}</div></h3>

                            </div>

                            <div class="form-group row">
                                <label for="billing_name" class="col-md-4 col-form-label text-md-right">{{ __('Név') }}</label>

                                <div class="col-md-6">

                                    <input
                                    type="text"
                                    name="billing_name"
                                    v-validate="'required|max:150'"
                                    :class="{'form-control': true, 'is-danger': errors.has('billing_name') }"

                                    v-model="checkout.user.billing_name"
                                    >
                                    <div v-show="errors.has('billing_name')" class="help is-danger">@{{ errors.first('billing_name') }}</div>

                                </div>
                            </div>

                            <div class="form-group row">
                                <label for="billing_city" class="col-md-4 col-form-label text-md-right">{{ __('Település') }}</label>

                                <div class="col-md-6">

                                    <input
                                    type="text"
                                    name="billing_city"
                                    :class="{'form-control': true, 'is-danger': errors.has('billing_city') }"
                                    v-validate="'required|max:100'"
                                    v-model="checkout.user.billing_city"
                                    >
                                    <div v-show="errors.has('billing_city')" class="help is-danger">@{{ errors.first('billing_city') }}</div>


                                </div>
                            </div>

                            <div class="form-group row">
                                <label for="billing_postcode" class="col-md-4 col-form-label text-md-right">{{ __('Irányítószám') }}</label>

                                <div class="col-md-6">


                                    <input
                                    type="text"
                                    name="billing_postcode"
                                    :class="{'form-control': true, 'is-danger': errors.has('billing_postcode') }"
                                    v-validate="'required|max:10'"
                                    v-model="checkout.user.billing_postcode"
                                    >
                                    <div v-show="errors.has('billing_postcode')" class="help is-danger">@{{ errors.first('billing_postcode') }}</div>



                                </div>
                            </div>

                            <div class="form-group row">
                                <label for="billing_address" class="col-md-4 col-form-label text-md-right">{{ __('Utca, házszám') }}</label>

                                <div class="col-md-6">


                                    <input
                                    type="text"
                                    name="billing_address"
                                    :class="{'form-control': true, 'is-danger': errors.has('billing_address') }"
                                    v-validate="'required|max:100'"
                                    v-model="checkout.user.billing_address"
                                    >
                                    <div v-show="errors.has('billing_address')" class="help is-danger">@{{ errors.first('billing_address') }}</div>


                                </div>
                            </div>

                            <div class="form-group row">
                                <label for="tax_number" class="col-md-4 col-form-label text-md-right">{{ __('Adószám') }}</label>

                                <div class="col-md-6">

                                    <input
                                    type="text"
                                    name="tax_number"
                                    :class="{'form-control': true, 'is-danger': errors.has('tax_number') }"
                                    v-validate="'max:30'"
                                    v-model="checkout.user.tax_number"
                                    >
                                    <div v-show="errors.has('tax_number')" class="help is-danger">@{{ errors.first('tax_number') }}</div>

                                </div>
                            </div>


                            <div class="form-group row">
                                <h3><div>{{ __('Szállítási adatok') }}</div></h3>

                            </div>
                            <div class="form-group row">
                                <label for="name" class="col-md-4 col-form-label text-md-right">{{ __('Telefonszám') }}</label>

                                <div class="col-md-6" >
                                    <!-- user.[phone] {{ checkout.user.phone }} | {{ checkout.user.phone0 }} -->
                                    <phone
                                            v-model="checkout.user.phone"
                                            :countries="phone_countries"
                                            data-vv-name="phone"
                                            inputOptions.placeholder="Telefonszám"
                                            data-vv-as="telefonszámot"
                                            :default-phone-number="checkout.user.phone0"
                                            v-validate="'required|phone_rule'"
                                            :class="{'form-control-phone': true, 'is-danger': errors.has('phone') }"
                                            ></phone>





                                        <div v-show="errors.has('phone')" class="help is-danger">{{ errors.first('phone') }}</div>

                                    </div>
                                </div>

                            <div class="form-group row">
                                <label for="shipping_name" class="col-md-4 col-form-label text-md-right">{{ __('Név') }}</label>

                                <div class="col-md-6">

                                    <input
                                    type="text"
                                    name="shipping_name"
                                    :class="{'form-control': true, 'is-danger': errors.has('shipping_name') }"
                                    v-validate="'required|max:150'"
                                    v-model="checkout.user.shipping_name"
                                    >
                                    <div v-show="errors.has('shipping_name')" class="help is-danger">@{{ errors.first('shipping_name') }}</div>


                                </div>
                            </div>

                            <div class="form-group row">
                                <label for="shipping_city" class="col-md-4 col-form-label text-md-right">{{ __('Település') }}</label>

                                <div class="col-md-6">


                                    <input
                                    type="text"
                                    name="shipping_city"
                                    :class="{'form-control': true, 'is-danger': errors.has('shipping_city') }"
                                    v-validate="'required|max:50'"
                                    v-model="checkout.user.shipping_city"
                                    >
                                    <div v-show="errors.has('shipping_city')" class="help is-danger">@{{ errors.first('shipping_city') }}</div>


                                </div>
                            </div>

                            <div class="form-group row">
                                <label for="name" class="col-md-4 col-form-label text-md-right">{{ __('Irányítószám') }}</label>

                                <div class="col-md-6">

                                    <input
                                    type="text"
                                    name="shipping_postcode"
                                    :class="{'form-control': true, 'is-danger': errors.has('shipping_postcode') }"
                                    v-validate="'required|max:50'"
                                    v-model="checkout.user.shipping_postcode"
                                    >
                                    <div v-show="errors.has('shipping_postcode')" class="help is-danger">@{{ errors.first('shipping_postcode') }}</div>


                                </div>
                            </div>

                            <div class="form-group row">
                                <label for="shipping_address" class="col-md-4 col-form-label text-md-right">{{ __('Utca, házszám') }}</label>

                                <div class="col-md-6">

                                    <input
                                    type="text"
                                    name="shipping_address"
                                    :class="{'form-control': true, 'is-danger': errors.has('shipping_address') }"
                                    v-validate="'required|max:50'"
                                    v-model="checkout.user.shipping_address" >
                                    <div v-show="errors.has('shipping_address')" class="help is-danger">@{{ errors.first('shipping_address') }}</div>


                                </div>
                            </div>


                            <hr>

                            <div class="checkout"  >
                                <a class="float-start btn btn-checkout" @click="tabIndex3">  {{ prevbtntext }}  </a>

                                <a class="float-end btn btn-checkout" @click="tabIndex5" >  {{ btntext }}  </a>
                                <!-- <a class="float-end btn btn-checkout btn-disable" v-else="!tabIndex5valid" >  {{ btntext }}  </a> -->
                            </div>
                        </div>
                    </b-tab>
                    <b-tab :title="__('__JSON__.Összesítés')" title-item-class="disabledTab">
                        <h2>{{ __('__JSON__.Összesítés')}}</h2>
                        <div class="checkout-cart-list" v-if="Object.keys(cart).length > 0">
                            <ul v-if="cart.cart.data">
                                <!-- {{ cart }} -->
                                <li class="cartdata" v-for="product in cart.cart.data">
                                    <!-- {{ product }} -->
                                    <div class="product-name">
                                        {{ product.product_name }}<br />
                                        <div class="packaging-qty">{{ product.packaging_qty }} {{ product.packaging_qty_unit }}</div>
                                    </div>



                                    <div class="cart-element">
                                        {{ product.qty }} {{__('__JSON__.db') }}
                                    </div>
                                    <div class="product-price">
                                        {{ product.price_plus_vat  * product.qty }} {{ product.currency }}

                                    </div>
                                </li>
                                <hr>
                                <li class="total">
                                    <div>
                                        {{ __('__JSON__.Termékek bruttó ára összesen')}}: <strong> {{ cart.products_total_price_plus_vat  }} {{cart.currency }}</strong><br />
                                        <span v-if="cart.cart.shipping_method != null ">
                                            {{ __('__JSON__.Szállítás díja')}}: <strong> {{ checkout.shipping_price }} {{  cart.currency  }}</strong><br />
                                        </span>
                                        <span v-if="coupon.status">
                                            <span v-if="coupon.free_delivery">
                                                {{ __('__JSON__.Szállítási kuponkedvezmény')}}: <strong> -{{ checkout.shipping_price }} {{ cart.currency  }} ({{ __('__JSON__.Ingyenes szállítás')}})</strong><br />
                                            </span>
                                        </span>

                                        <span v-if="checkout.payment_price != null && checkout.payment_price != 0 ">
                                            {{ __('__JSON__.Utánvét díja')}}: <strong> {{ checkout.payment_price  | cart.currency  }}</strong><br />
                                        </span>
                                        <span v-if="coupon.status">

                                            <span v-if="coupon.discount_value > 0 ">
                                                {{ __('__JSON__.Kuponkedvezmény')}}: <strong> {{ parseFloat(coupon.discount_value).toFixed(floatingPrecision)  }} {{ cart.currency }}</strong><br />
                                            </span>
                                        </span>
                                        {{ __('__JSON__.Fizetendő összesen')}}: <strong> {{ checkout_total_price }} {{ cart.currency }}</strong>

                                    </div>
                                </li>
                                <li class="total">
                                    <div ><br />

                                        {{ __('__JSON__.Szállítás módja') }}: <strong> {{ cart.cart.shipping_method | shipping_method_text  }}</strong><br />
                                        {{ __('__JSON__.Fizetés módja') }}: <strong> {{  payment_method_text  }}</strong><br />
                                    </div>

                                </li>

                            </ul>

                            <div v-if="!cart.cart.data">
                                {{ __('__JSON__.A kosár üres') }}
                            </div>
                        </div>
                        <div class="w80" >

                            <div class="well">
                                <h4>{{ __('__JSON__.Kupon kód') }}:  </h4>
                                <div class="row">
                                    <div class="col-md-6">
                                        <div class="mb-2 input-group coupon-box">
                                            <input
                                            type="text"
                                            name="coupon_code"
                                            :class="{'form-control': true, 'is-danger': errors.has('coupon_code') }"
                                            v-validate="'max:30'"
                                            v-model="cart.cart.coupon_code"
                                            v-if="coupon.status != 'OK' "
                                            >
                                            <div class="coupon-code-container" v-if="coupon.status == 'OK'  ">
                                                <input
                                                type="text"
                                                name="coupon_code"
                                                :class="{'form-control': true, 'is-danger': errors.has('coupon_code') }"
                                                v-validate="'max:30'"
                                                disabled="disabled"
                                                v-model="cart.cart.coupon_code"
                                                >
                                                <div class="coupon-delete" @click="deleteCouponCode"> </div>
                                            </div>
                                            <div v-show="errors.has('coupon_code')" class="help is-danger">@{{ errors.first('coupon_code') }}</div>
                                            <div class="input-group-append" v-if="coupon.status != 'OK'">
                                                <span class="input-group-text" >
                                                    <button type="button" class="btn btn-xs btn-default" @click="checkCouponCode" >{{ __('__JSON__.Kupon ellenőrzése') }}</button>
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="p-0 col-md-6 coupon-ok" v-if="coupon.status == 'OK' && !coupon.error">
                                        <i class="fas fa-check"></i> {{ __('__JSON__.kupon elfogadva') }}
                                    </div>
                                    <div class="p-0 col-md-6 coupon-error" v-if="coupon.error">
                                        <i class="fas fa-exclamation-square"></i> {{coupon.error}}
                                    </div>
                                </div>

                            </div>

                            <div class=" well" >
                            </div>
                            <checkout-comment v-model="cart.cart.comment" :label="__('__JSON__.Megjegyzés')"></checkout-comment>


                            <!-- <div class=" well kuldjegykavet" >
                            <h4>#küldjegykávét ajándék</h4>

                            Bővebben az akcióról <a href="/kuldj-egy-kavet">itt olvashatsz</a>!
                            <br /><br />
                            <label for="" v-if="cart" class="form-check-label">
                            <input type="checkbox"   v-model="cart.gift">
                            A rendelés nem saját számomra történik, hanem felajánlom az alábbi szervezetek részére:
                        </label>

                        <br /><br />
                        <span v-if="cart.gift">
                        <ul class="giftlist">
                        <li v-for="el in giftlist">
                        <label class="form-check-label" for="giflist">
                        <input type="radio" name="giflist" :value="el.id" v-model="checkout.gift"> {{el.name}}
                    </label>

                </li>
            </ul>

            <checkout-comment v-model="cart.cart.comment2" :label="'Üzenetem a kórház dolgozóinak'"></checkout-comment>
        </span>
    </div> -->
    <div class="well " >
        <br /><br />
        <label class="form-check-label" for="is_terms">

            <strong>{{ __('__JSON__.Figyelem! Fizetési kötelezettséggel járó megrendelés!')}}</strong>
        </label>
        <br />
        <label class="form-check-label" for="is_terms">

            <input type='checkbox' name='is_terms'    v-model='checkout.is_terms' >
        <span v-html="elfogadom"></span>.
        </label>
    </div>
    <div class="well " >
        <label class="form-check-label" for="is_privacy">

            <input type='checkbox' name='is_privacy'   v-model='checkout.is_privacy' >
            <span v-html="elfogadom2"></span>.
        </label>
    </div>


    <hr>
    <div class="checkout"  >
        <a class="float-start btn btn-checkout" @click="tabIndex4">  {{ prevbtntext }}  </a>

        <a class="float-end btn btn-checkout-big" @click="processOrder" v-if="checkout.is_terms && checkout.is_privacy"> {{ __('__JSON__.A rendelés véglegesítése') }} </a>
        <a class="float-end btn btn-checkout-big btn-disabled disabled" disabled   v-else="!(checkout.is_terms && checkout.is_privacy)">  {{ __('__JSON__.A rendelés véglegesítése') }} </a>
    </div>
</div>
</b-tab>
</b-tabs>


</div>

</div>


</div>



</template>
<script>
import Vue from 'vue';
// import Lang from 'lang.js';
import mixin from '../../mixin.js'
// const default_locale = window.default_language;
// const fallback_locale = window.fallback_locale;
// const messages = window.messages;
// console.log(messages);
// Vue.prototype.trans = new Lang( { messages, locale: default_locale, fallback: fallback_locale } );


export default {
    mixins: [mixin],
    props: ['user', 'cart', 'checkout', 'route', 'cartmenu_loading', 'btntext', 'prevbtntext', 'giftlist'],
    inject: ['$validator'],
    data () {
        return {
            showParcelPointModal: false,
            // errors: [],
            // offset: 0,

            elfogadom: this.__("__JSON__.Elolvastam és elfogadom az <a target=\"_blank\" href=\"/hu/aszf\">ASZF-ben</a> megfogalmazottakat"),
            elfogadom2: this.__("__JSON__.Elolvastam és elfogadom az <a target=\"_blank\" href=\"/hu/adatkezelesi-nyilatkozat\">adatkezelésben</a> megfogalmazottakat"),
            phone_countries: [],
            coupon_code_status: false,
            button_disabled: false,
            success: false,
            error: false,
            html: null,
            tabName: '',
            tabIndex: 1,
            shipping_methods: null,
            shipping_types: null,
            payment_methods: null,
            // payment_price: null,
            menu_visible: this.value,
            cartmenuloading: false,
            userdata: this.user,
            userdata_orig: Object.assign({}, this.user),
            shipping_method: null,
            saved_coupon_code: null,
            // tabIndex5valid: false,
            coupon: {
                status: '',
                discount_value: 0
            }
            // payment_method_text: ''
        }
    },
    methods: {
        deleteCouponCode() {
            this.saved_coupon_code = null;
            this.cart.cart.coupon_code = null;
            this.coupon = {
                status: '',
                error: null,
                discount_value: 0
            }
        },
        vParseInt(val) {
            console.log('vParseInt');
            if (this.cart.currency == "Ft" || this.cart.currency == "ft") {
                return parseInt(val);
            } else {
                // console.log(val, val.toFixed(floatingPrecision));
                return Number(val.toFixed(this.floatingPrecision));
            }
        },
        checkCouponCode() {
            if (this.cart.cart.coupon_code) {
                let loader = this.$loading.show();
                axios
                .post('/api/v1/coupon/check', {

                    coupon_code:  this.cart.cart.coupon_code,

                })
                .then(response => {
                    loader.hide();

                    if (response.data.status == "CODE_OK") {
                        if (this.coupon.min_purchase != "0") {
                            console.log('min_purchase nem nulla!');
                            // console.log('this.cart.products_total_price_plus_vat:');
                            // console.log(this.cart.products_total_price_plus_vat);
                            // console.log('this.coupon.min_purchase:');
                            // console.log(response.data.min_purchase);
                            if (this.cart.products_total_price_plus_vat < response.data.min_purchase) {
                                // alert, hogy nem jo a
                                // NOTE: uzenetet irjon, es a szerver oldalon is ellenorizzen vasarlaskor
                                this.coupon = {
                                    status: 'ERROR_MIN_PURCHASE',
                                    discount_value: 0,
                                    error: 'Minimum rendelési érték (' + response.data.min_purchase + ') Ft esetén használható fel a kupon!'
                                };

                            } else {
                                this.coupon = response.data;
                                this.coupon.status = "OK";
                                this.setShippingPrice();
                            }
                        } else {
                            this.coupon = response.data;
                            this.coupon.status = "OK";
                            this.setShippingPrice();
                        }
                    } else {
                        this.coupon = {
                            status: response.data.status,
                            discount_value: 0,
                            error: 'A kuponkód nem használható fel!'
                        };
                    }

                });
            }
        },
        // handleTabChange: function(tabIndex, newTab, oldTab) {
        //     // return false;
        //     console.warn(oldTab.title);
        //     // this.tabName = oldTab.title;
        //     // if (tabIndex == 5) {
        //     //     // console.log(app.$refs.gmap.$refs.map1);
        //     //     setTimeout(function(){
        //     //         // console.log('resize, timeout?');
        //     //         app.$refs.gmap.$refs.map1.resizePreserveCenter()
        //     //         // app.$refs.gmap.updateCenter()
        //     //         , 200});
        //     //     }
        // },
        offset: function() {
            if (this.$root.isFixedHeader) {
                var ret = -120;
            } else {
                var ret = -50;
            }

            return ret;
        },
        tabIndex1() {

            this.tabName='A kosár';
            this.tabIndex = 1;
            if (this.$root.isFixedHeader) {
                this.$scrollTo('#checkout_top', 500, {offset: this.offset});
            }
        },
        tabIndex2() {

            this.setPaymentPrice();
            // console.log('click -> 2');
            this.tabName='Szállítási mód';
            this.tabIndex = 2;
            if (this.$root.isFixedHeader) {
                this.$scrollTo('#checkout_top', 500, {offset: this.offset});
            }
        },
        tabIndex3() {
            if (this.cart.cart.coupon_code) {
                this.saved_coupon_code =  this.cart.cart.coupon_code;
            }
            // console.log('click -> 3');
            this.tabName='Fizetési mód';
            this.tabIndex = 3;
            if (this.$root.isFixedHeader) {
                this.$scrollTo('#checkout_top', 500, {offset: this.offset});
            }
        },
        tabIndex4() {
            // console.log('click -> 4');
            this.tabIndex = 4;
            this.tabName='Szállítási és számlázási cím';
            if (this.$root.isFixedHeader) {
                this.$scrollTo('#checkout_top', 500, {offset: this.offset});
            }
        },
        tabIndex5() {
            return this.$validator.validateAll()
            .then(result => {
                if (!result) {
                    this.$notify({
                    type: "error",
                    title: this.__("__JSON__.Szállítási és számlázási cím"),
                    text: this.__("__JSON__.Egy vagy több megadott adat hibás!"),
                    position: "left",
                    group: 'appnotif',

                    autohide: false,
                    timeout:5000,
                });
                    return false;
                    // this.tabIndex5valid = false;
                    } else {
                        // this.tabIndex5valid = true;
                        this.tabIndex = 4;
                        if (this.saved_coupon_code) {
                            this.cart.cart.coupon_code = this.saved_coupon_code;
                        }
                        if (this.coupon.error) {
                            this.coupon.status = '';
                            this.coupon.error = null;
                        }
                        if (this.cart.cart.coupon_code) {
                            this.checkCouponCode();
                        }
                        this.checkout.is_privacy = 0;
                        this.checkout.is_terms = 0;
                        this.tabName='Összesítés';
                        this.tabIndex = 5;
                        if (this.$root.isFixedHeader) {
                            this.$scrollTo('#checkout_top', 500, {offset: this.offset});
                        }
                }
            });
        },
        processOrder() {
            console.log('processOrder()');
            if (!this.button_disabled) {
                this.button_disabled = true;
                let loader = this.$loading.show();
                axios
                .post(this.route, {
                    checkout: this.checkout,
                    comment: this.cart.cart.comment,
                    comment2: this.cart.cart.comment2,
                    coupon_code:  this.cart.cart.coupon_code,
                    payment_method:  this.cart.cart.payment_method,
                    shipping_method:  this.cart.cart.shipping_method
                })
                .then(response => {
                    loader.hide();
                    // loading(false);
                    console.log('response.data:' + JSON.stringify(response.data));
                    // console.log(response.data);
                    // console.log(response.data.success);
                    if (response.data.success) {
                        this.success = response.data.success;
                        this.$scrollTo('#checkout_top', 500, {offset: this.offset} );
                        this.$root.loadCart(true);
                        // axios
                        // .get('/api/v1/cart', {})
                        // .then(response => {
                        //     this.cart = response.data
                        // });
                    }
                    if (response.data.error) {
                        this.error = response.data.error;
                        this.$scrollTo('#checkout_top', 500, {offset: this.offset} );
                        this.$root.loadCart(true);
                    }
                    if (response.data.redirect) {
                        document.location.href = response.data.redirect;
                    }
                    if (response.data.html) {
                        this.html = response.data.html;
                        this.$scrollTo('#checkout_top', 500, {offset: this.offset} );

                        Vue.nextTick(function() {
                            document.getElementById("SimplePayForm").submit();
                        });

                        // this.$root.loadCart();

                    }
                });
            }
        },
        reload() {
            console.log('reload');
            this.$forceUpdate();
        },
        changeShippingMethod() {
            console.warn('changeShippingMethod() ajax');

            self = this;
            if (this.cart.cart) {
                Vue.nextTick(function() {
                    axios
                    // .post('/api/v1/cart/shipping', {shipping_method: self.cart.cart.shipping_method})
                    .post('/api/v1/cart/shipping', {shipping_method: self.cart.cart.shipping_method ? self.cart.cart.shipping_method.id : null})

                    .then(response => {
                        console.warn(response);
                        console.log('^ /api/v1/cart/shipping');
                        self.checkout.shipping_price = self.setShippingPrice();
                    });
                    // if (self.cart.cart.shipping_method == 'FOXH') {
                    if (self.cart.cart.shipping_method && self.cart.cart.shipping_method.select_required == '0') {
                        if (self.user && self.user.id) {
                            self.checkout.user.shipping_city = self.userdata_orig.shipping_city ;
                            self.checkout.user.shipping_postcode = self.userdata_orig.shipping_postcode;
                            self.checkout.user.shipping_address = self.userdata_orig.shipping_address;
                            self.checkout.user.shipping_name = self.userdata_orig.shipping_name;
                        }
                    }
                });
            }
        },
        changePaymentMethod() {
            console.log('changePaymentMethod()');
            var self = this;
            if (self.cart.cart) {
                Vue.nextTick(function () {

                    var index = self.payment_methods.findIndex((k) => k.id === self.cart.cart.payment_method);
                    // self.payment_method_text = self.payment_methods[index].name;
                    axios
                    .post('/api/v1/cart/payment', {payment_method: self.cart.cart.payment_method})
                    .then(response => {
                        // console.log('response');
                        // console.log(response);
                        self.setPaymentPrice();
                    });
                });
            }
        },
        // __(text) {
        //     // console.log(text);
        //     return this.trans.get(text)
        // },
        setPaymentPrice() {

            console.log('setPaymentPrice()');
            console.log(this.cart.cart.payment_method);
            var ret = 0;
            if (this.payment_methods) {
                for (var i = 0; i < this.payment_methods.length; i++) {
                    if (this.payment_methods[i].id == this.cart.cart.payment_method) {
                        console.log(this.payment_methods[i]);
                        this.checkout.payment_price = (this.payment_methods[i].payment_price);
                        // console.log(parseInt(this.payment_methods[i].payment_price));
                        // console.log(this.checkout.payment_price);

                        this.$forceUpdate();
                    }
                }

            } else {
                console.warn('nincs shipping_methods!');
            }

            return ret;
        },
        setShippingPrice() {
            console.log('setShippingPrice()', this.cart.cart.shipping_method);
            var ret = 0;
            // console.log(this.shipping_methods);
            // console.log('this.cart.cart.shipping_method='+ this.cart.cart.shipping_method);
            if (this.shipping_methods) {
                for (var i = 0; i < this.shipping_methods.length; i++) {
                    // console.log(i, this.shipping_methods[i].shipping_type , this.cart.cart.shipping_method.id);
                    if (this.shipping_methods[i].shipping_type == this.cart.cart.shipping_method?.id) {
                        // console.log('this.cart.products_total_price_plus_vat');
                        // console.log(this.cart.products_total_price_plus_vat);
                        // console.log('parseInt(this.coupon.discount_value):');
                        // console.log(parseInt(this.coupon.discount_value));

                        // console.log('->',this.shipping_methods[i].shipping_type,this.vParseInt(this.cart.products_total_price_plus_vat - this.coupon.discount_value)) >= this.vParseInt(this.shipping_methods[i].order_price_from) && this.vParseInt(this.cart.products_total_price_plus_vat - this.coupon.discount_value) <= this.vParseInt(this.shipping_methods[i].order_price_to);
                        if ((this.vParseInt(this.cart.products_total_price_plus_vat - this.coupon.discount_value)) >= this.vParseInt(this.shipping_methods[i].order_price_from) && this.vParseInt(this.cart.products_total_price_plus_vat - this.coupon.discount_value) <= this.vParseInt(this.shipping_methods[i].order_price_to) ) {
                        // if (parseInt(this.cart.products_total_price_plus_vat)   >= parseInt(this.shipping_methods[i].order_price_from) && parseInt(this.cart.products_total_price_plus_vat) <= parseInt(this.shipping_methods[i].order_price_to) ) {
                            // console.log(this.shipping_methods[i]);
                            ret = (this.shipping_methods[i].shipping_price);
                            this.checkout.shipping_price = ret;
                            // console.log('ret:',ret);
                            // console.log(this.checkout.shipping_price);
                            this.$forceUpdate();
                            // this.checkout_total_price;
                            // console.log('ret=' + ret);
                        }
                    }
                }
            } else {
                console.warn('nincs shipping_methods!');
            }

            return ret;
        }
    },
    watch: {
        'cart.checkout_total_price_plus_vat': function(newVal, oldVal) {
            // console.log('WATCH!!!!!')
            this.setShippingPrice();
            this.setPaymentPrice();
        }
        // offset: function() {
        //     if (this.$root.isFixedHeader) {
        //         this.offset = -85;
        //     } else {
        //         this.offset =  0;
        //     }
        //
        // }
    },
    computed: {
        payment_method_text: function() {
            var ret = '';
            // var self = this;
            if (this.payment_methods ) {
                // Vue.nextTick(function () {
                for (var i = 0; i < this.payment_methods.length; i++) {
                    if (this.payment_methods[i].id == this.cart.cart.payment_method) {
                        ret = this.payment_methods[i].name;
                    }
                }
                // var index = self.payment_methods.findIndex((k) => k.id === self.cart.cart.payment_method);
                // ret = self.payment_methods[index].name;

                // });
            }
            // this.checkout.payment_price = ret;
            return ret;
        },
        shipping_price: function() {
            // console.log('shipping_price()');
            // console.log( this.cart);
            this.checkout.shipping_price = 0;
            var ret = 0;
            if (this.shipping_methods) {

                for (var i = 0; i < this.shipping_methods.length; i++) {
                    if (this.shipping_methods[i].shipping_type == this.cart.cart.shipping_method) {
                        // console.log(this.shipping_methods[i]);
                        // console.log('parseInt(this.coupon.discount_value):');
                        // console.log(parseInt(this.coupon.discount_value));
                       if ((this.vParseInt(this.cart.products_total_price_plus_vat - this.coupon.discount_value)) >= this.vParseInt(this.shipping_methods[i].order_price_from) && this.vParseInt(this.cart.products_total_price_plus_vat  - this.coupon.discount_value) <= this.vParseInt(this.shipping_methods[i].order_price_to) ) {
                        // if (parseInt(this.cart.products_total_price_plus_vat)  >= parseInt(this.shipping_methods[i].order_price_from) && parseInt(this.cart.products_total_price_plus_vat) <= parseInt(this.shipping_methods[i].order_price_to) ) {
                            ret = this.vParseInt(this.shipping_methods[i].shipping_price);
                            // console.warn(this.shipping_methods[i]);
                            this.$root.$forceUpdate();
                        }
                    }

                }

            }
            // this.checkout.shipping_price = ret;
            console.log('shipping_price --------');
            return ret;
        },
        checkout_total_price() {
            // console.warn('=================checkout_total_price()');
            // // console.log(this.cart);
            // console.log('this.cart.products_total_price_plus_vat:', this.cart.products_total_price_plus_vat);
            // console.log('this.checkout.shipping_price:',this.checkout.shipping_price);
            // console.log('this.checkout.payment_price:', this.checkout.payment_price);
            // console.log('this.coupon.discount_value:', this.coupon.discount_value);


            //NOTE: szerintem nem kellene kerekiteni
            var total = this.vParseInt(this.cart.products_total_price_plus_vat
            + this.checkout.shipping_price
            + this.checkout.payment_price
            - this.coupon.discount_value);
            if (this.coupon.free_delivery) {
                total = this.vParseInt(total - this.checkout.shipping_price);
            }
            // console.log('total:');
            // console.log(total);
            // console.log(total);
            return total;
            // return new Date();
        }
    },
    created() {
        this.checkout.payment_price = 0;
        console.log('Checkout.vue Component mounted.');
        this.cartmenuloading = this.cartmenu_loading;
        this.tabName = 'Szállítási mód';
        this.$forceUpdate();
        this.tabName = 'A kosár';
        this.$root.$forceUpdate();
        // this.checkout.user = this.user;
        this.$set(this.checkout, 'user', this.user);
        console.log('this.cart');
        console.log(this.cart);
        axios
        .get('/api/v1/shipping', {})
        .then(response => {
            this.shipping_methods = response.data.shipping_methods;
            this.shipping_types = response.data.shipping_types;
            // console.log('this.shipping_methods');
            // console.log(this.shipping_methods);
            // this.shipping_price();
            this.changeShippingMethod();
            //     console.log(response.data);
        });
        axios
        .get('/api/v1/payment', {})
        .then(response => {
            // console.warn(response);
            // this.payment_price();
            this.payment_methods = response.data;
            this.changePaymentMethod();

            // console.log('this.payment_methods');
            // console.log(this.payment_methods);
        });

        axios
        .get('/api/v1/countries/phone', {})
        .then(response => {

            this.phone_countries = response.data;

        });

        // this.shipping_price;
        // console.log('trans');
        // console.log(this.trans.get('__JSON__.name'));
    },
    updated() {

        // console.log('Checkout Component updated.');
        // this.initClick();
    }
}
</script>
<style lang="css">
.img-hover {
    cursor: pointer;
}
.disabledTab{
    pointer-events: none;
}
</style>
